import React from 'react';
import { MessageSquare, Sparkles, Mic, FileText, AlertTriangle, Heart, History, Activity, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export const ToolsSection = () => {
  const handleToolClick = () => {
    window.location.href = '/signup';
  };
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-2740" data-mp="158015bve0q56">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-2741" data-mp="108dmcxzwv1u9" />

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-2742" data-mp="qaz7v3xjsn4l">
        <div className="text-center mb-20" data-id="element-2743" data-mp="m8ccit1o4k2n">
          <div className="inline-block border border-[#FF0000]/30 bg-[#FF0000]/5 px-3 py-1 mb-4" data-id="element-2744" data-mp="m9nq1kkx166y">
            <span className="text-[#FF0000] font-mono text-xs tracking-[0.2em] uppercase" data-id="element-2745" data-mp="2kmnpxez2t5t7">
              Full Suite Access
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-2746" data-mp="21wmnd3hziyld">
            ToxicDetector{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF0000] to-[#FFD700]" data-id="element-2747" data-mp="26wr1imvf7h8f">
              Arsenal
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto font-mono" data-id="element-2748" data-mp="1wxjra8jzg2pj">
            Comprehensive forensic tools to analyze, document, and protect your
            reality.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16" data-id="element-2749" data-mp="2plxown75sx0k">
          <ToolCard icon={<MessageSquare size={20} data-id="element-2751" data-mp="2bvc5mxdsml25" />} title="Toxicity Analyzer" subtitle="Deep pattern recognition" code="TXT_ANA_01" onClick={handleToolClick} data-id="element-2750" data-mp="2po1q2xdobhx5" />
          <ToolCard icon={<Sparkles size={20} data-id="element-2753" data-mp="33l6vcv5kccrc" />} title="Chat Rewriter" subtitle="De-escalation protocols" code="RWR_PRO_V2" onClick={handleToolClick} data-id="element-2752" data-mp="33lqbc6bnkr2q" />
          <ToolCard icon={<Mic size={20} data-id="element-2755" data-mp="3i6ky3h4seig4" />} title="Voice Forensics" subtitle="Tone & stress analysis" code="AUD_FOR_03" onClick={handleToolClick} data-id="element-2754" data-mp="3i7dze2kz8fqv" />
          <ToolCard icon={<FileText size={20} data-id="element-2757" data-mp="348wf6eua5ldp" />} title="Dossier Generator" subtitle="Evidence compilation" code="DOC_GEN_04" onClick={handleToolClick} data-id="element-2756" data-mp="39661hlmdhgxb" />
          <ToolCard icon={<AlertTriangle size={20} data-id="element-2759" data-mp="2uil0pycyztsk" />} title="Gaslight Detector" subtitle="Reality distortion alerts" code="GAS_DET_05" onClick={handleToolClick} data-id="element-2758" data-mp="2uj4gp9j2883y" />
          <ToolCard icon={<Heart size={20} data-id="element-2761" data-mp="2ljzik4beugsb" />} title="Viability Predictor" subtitle="Long-term projection" code="REL_PRE_06" onClick={handleToolClick} data-id="element-2760" data-mp="2lj7nculq6l2k" />
          <ToolCard icon={<History size={20} data-id="element-2763" data-mp="2bmblh7qc0x6z" />} title="Pattern Timeline" subtitle="Historical tracking" code="HST_TRK_07" onClick={handleToolClick} data-id="element-2762" data-mp="2bljte6vy1hlg" />
          <ToolCard icon={<Activity size={20} data-id="element-2765" data-mp="2behpp0xcu345" />} title="Sanity Meter" subtitle="Emotional baseline" code="SAN_MTR_08" onClick={handleToolClick} data-id="element-2764" data-mp="26hhlkvk2fafo" />
        </div>

        {/* Warning Flag Visual Break */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center justify-center mb-20" data-id="element-2766" data-mp="1ir534qr71vau">
          <div className="relative group" data-id="element-2767" data-mp="zxi1ohi1iafx">
            <div className="absolute -inset-8 bg-[#FF0000]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2768" data-mp="14xm6ha9l5gqb" />
            <div className="relative z-10 w-[280px] h-[280px] md:w-[320px] md:h-[320px] mx-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-2769" data-mp="36lialvjkuatf">
              {/* Inline SVG Warning Flag */}
              <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[0_10px_20px_rgba(255,0,0,0.2)]" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2770" data-mp="3bmo806o6mm9a">
                {/* Outer Rings */}
                <circle cx="100" cy="100" r="90" stroke="#FF0000" strokeWidth="1" strokeDasharray="4 8" className="animate-[spin_30s_linear_infinite]" data-id="element-2771" data-mp="3lc7tzl76yw8d" />
                <circle cx="100" cy="100" r="75" stroke="#374151" strokeWidth="2" data-id="element-2772" data-mp="24yhms5krzrui" />

                {/* Inner Hexagon */}
                <path d="M100 35 L156.29 67.5 L156.29 132.5 L100 165 L43.71 132.5 L43.71 67.5 Z" fill="#0A0A0A" stroke="#FF0000" strokeWidth="2" data-id="element-2773" data-mp="kg72uarghxrr" />

                {/* Warning Triangle */}
                <path d="M100 55 L135 125 H65 Z" fill="#FF0000" fillOpacity="0.1" stroke="#FF0000" strokeWidth="3" strokeLinejoin="round" data-id="element-2774" data-mp="aoasa086of6n" />

                {/* Exclamation Mark */}
                <rect x="96" y="75" width="8" height="25" rx="4" fill="#FF0000" className="animate-pulse" data-id="element-2775" data-mp="3izxa6zsiqacd" />
                <circle cx="100" cy="112" r="4" fill="#FF0000" className="animate-pulse" data-id="element-2776" data-mp="1m5sl44o87uee" />

                {/* Crosshairs */}
                <path d="M100 10 V25 M100 175 V190 M10 100 H25 M175 100 H190" stroke="#FF0000" strokeWidth="2" data-id="element-2777" data-mp="1fnz8fl5qmisj" />

                {/* Radar Sweep */}
                <path d="M100 100 L165 62.5 A75 75 0 0 1 175 100 Z" fill="#FF0000" opacity="0.1" className="animate-[spin_3s_linear_infinite]" style={{
                transformOrigin: '100px 100px'
              }} data-id="element-2778" data-mp="16qyobqppb6uw" />
              </svg>
            </div>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/80 backdrop-blur border border-[#FF0000]/30 px-4 py-1.5 rounded-full flex items-center gap-2 whitespace-nowrap shadow-[0_0_15px_rgba(255,0,0,0.2)] z-20" data-id="element-2779" data-mp="1pmyj19a2coi6">
              <AlertTriangle size={12} className="text-[#FF0000] animate-pulse" data-id="element-2780" data-mp="3w9or121exae" />
              <span className="text-[#FF0000] font-mono text-[10px] font-bold tracking-[0.2em] uppercase" data-id="element-2781" data-mp="8w4g15pq5ovz">
                Critical Alerts Enabled
              </span>
            </div>
          </div>
        </motion.div>

        <div className="text-center relative" data-id="element-2782" data-mp="hxcepow5krql">
          <div className="absolute top-1/2 left-0 w-full h-px bg-gray-900 -z-10" data-id="element-2783" data-mp="mv44ac9bs1rm" />

          <div className="inline-block bg-[#050505] px-8" data-id="element-2784" data-mp="mt1entc34anf">
            <p className="text-gray-500 font-mono text-xs mb-6 uppercase tracking-widest" data-id="element-2785" data-mp="rsnsa3vtrswr">
              Pro License Includes All Modules
            </p>

            <a href="/signup" className="group relative inline-flex items-center gap-3 bg-[#FF0000] text-white px-10 py-4 font-bold text-lg uppercase tracking-wider overflow-hidden hover:bg-red-600 transition-all shadow-[0_0_20px_rgba(255,0,0,0.4)] hover:shadow-[0_0_30px_rgba(255,0,0,0.6)]" data-id="element-2786" data-mp="10m0wi1zcagy5">
              <div className="absolute inset-0 w-full h-full bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-2787" data-mp="lg869wy61ni8"></div>
              <span className="relative z-10" data-id="element-2788" data-mp="gkasnyeaev95">Initialize Free Scan</span>
              <ArrowRight className="relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-2789" data-mp="uhfutnavr9z4" />

              {/* Corner Accents on Button */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 border-white opacity-50" data-id="element-2790" data-mp="2qjutn9x4zt9" />
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b-2 border-white opacity-50" data-id="element-2791" data-mp="3txmm0eprb63h" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};
interface ToolCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  code: string;
  onClick?: () => void;
}
const ToolCard = ({
  icon,
  title,
  subtitle,
  code,
  onClick
}: ToolCardProps) => {
  return <motion.div whileHover={{
    y: -4
  }} onClick={onClick} className="bg-[#0a0a0a] border border-gray-800 p-6 relative group overflow-hidden hover:border-[#FF0000]/50 transition-colors cursor-pointer" data-id="element-2792" data-mp="3b6v2ikc21zbd">
      {/* Corner Brackets */}
      <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-gray-800 group-hover:border-r-[#FF0000] transition-colors" data-id="element-2793" data-mp="35vhn8j1rsrx9" />

      <div className="flex items-start justify-between mb-4" data-id="element-2794" data-mp="2w43erlruchrz">
        <div className="text-gray-500 group-hover:text-[#FF0000] transition-colors" data-id="element-2795" data-mp="3jsmq6a66taoa">
          {icon}
        </div>
        <span className="text-[9px] font-mono text-gray-700 group-hover:text-[#FF0000]/50 transition-colors" data-id="element-2796" data-mp="3or7o22xyvi9k">
          {code}
        </span>
      </div>

      <h3 className="font-bold text-white text-sm uppercase tracking-wide mb-1 group-hover:text-[#FF0000] transition-colors" data-id="element-2797" data-mp="39xcojnjpb5b1">
        {title}
      </h3>
      {subtitle && <p className="text-gray-500 text-xs font-mono leading-relaxed group-hover:text-gray-400" data-id="element-2798" data-mp="1yei9d82iuoaa">
          {subtitle}
        </p>}

      {/* Hover Scan Line */}
      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#FF0000] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-2799" data-mp="3lv0h4z03mn11" />
    </motion.div>;
};